export default __webpack_public_path__ + "static/media/product3.0153432d.png";